/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BookGeneratedEventAddressPayload } from './BookGeneratedEventAddressPayload';
import type { DateTime } from './DateTime';
export type BookGeneratedEventPayload = {
    eventRuleId: number;
    eventCategoryId?: number;
    start: DateTime;
    end: DateTime;
    paymentType?: BookGeneratedEventPayload.paymentType;
    orderId?: string;
    useCredits?: boolean;
    address?: BookGeneratedEventAddressPayload;
    locationSelection?: BookGeneratedEventPayload.locationSelection;
};
export namespace BookGeneratedEventPayload {
    export enum paymentType {
        ONLINE = 'online',
        CASH = 'cash',
        INVOICE = 'invoice',
    }
    export enum locationSelection {
        VIRTUAL = 'virtual',
        ONSITE = 'onsite',
    }
}

